module.exports = "/_next/static/images/globe-489b8c5f1656202901b9096166af77ee.png";